import React from 'react';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

import { Question } from '../../types/DataTypes';
import { AssessmentResultAnswer, SubAnswer } from '../../types';

type Props = {
  name: string;
  question: Question;
  answer: AssessmentResultAnswer;
  answerUidToAnswerMap: { [key: string]: SubAnswer };
  onAnswerChange: (question: Question, updatedAnswer: AssessmentResultAnswer) => void;
  disabled?: boolean;
}

const MultipleChoice: React.FC<Props> = (props: Props) => {
  const {
    question, onAnswerChange, answer, disabled, name, answerUidToAnswerMap,
  } = props;

  const handleMultipleChoiceChange = (_: React.ChangeEvent<HTMLInputElement>, answerUid: string) => {
    onAnswerChange(question, {
      type: question.questionType,
      answers: [
        answerUidToAnswerMap[answerUid],
      ],
    });
  };

  const defaultAnswerUid = answer.answers.length > 0 ? answer.answers[0]?.uid : '';

  return (
    <RadioGroup
      name={name}
      onChange={handleMultipleChoiceChange}
      value={defaultAnswerUid}
    >
      {
        question.answers?.map((possibleAnswer) => (
          <FormControlLabel
            key={possibleAnswer?.uid}
            control={<Radio />}
            value={possibleAnswer?.uid}
            label={possibleAnswer?.text}
            disabled={disabled}
          />
        ))
      }
    </RadioGroup>
  );
};

export default MultipleChoice;
